import { render, staticRenderFns } from "./SearchView.vue?vue&type=template&id=de0184aa"
import script from "./SearchView.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchView.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports